<template>
  <navbar
    position="fixed"
    type="default"
    :transparent="transparent"
    :color-on-scroll="colorOnScroll"
    :paddingTop="paddingTop"
    menu-classes="ml-auto"
  >
    <template slot-scope="{}">      
      <router-link v-popover:popover1 class="navbar-brand" to="/">
        <img v-lazy="'/img/logo_mini.png'" width="100%"/>
      </router-link>
    </template>
    <template slot="navbar-menu">
      <li class="nav-item">
        <router-link
          class="nav-link"
          to="/home"
        >
          <p>{{$t(`top_menu_main`)}}</p>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          class="nav-link"
          to="/map"
        >
          <p>{{$t(`top_menu_map`)}}</p>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          class="nav-link"
          to="/reward"
        >
          <p>{{$t(`top_menu_reward`)}}</p>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          class="nav-link"
          to="/mainsale"
        >
          <p>{{$t(`top_main-sale`)}}</p>
        </router-link>
      </li>
      <li v-if="$store.state.account.presaleStarted" class="nav-item">
        <router-link
          class="nav-link"
          to="/presale"
        >
          <p>{{$t(`top_pre-sale`)}}</p>
        </router-link>
      </li>
      <!-- <li class="nav-item">
        <router-link
          class="nav-link"
          to="/event"
        >
          <p>{{$t('Join Event')}}</p>
        </router-link>
      </li> -->
      <!-- <li class="nav-item">
        <router-link
          class="nav-link"
          to="/land"
        >
          <p>{{$t(`main_land`)}}</p>
        </router-link>
      </li> -->
      <drop-down
              tag="li"
              v-bind:title="$t($i18n.locale)"
              class="nav-item"
      >
        <div @click="$i18n.locale='en'" class="dropdown-item">
          English
        </div>
        <div @click="$i18n.locale='ko'" class="dropdown-item">
          한국어
        </div>
        <div @click="$i18n.locale='ch-zn'" class="dropdown-item">
          中文
        </div>
        <div @click="$i18n.locale='ja'" class="dropdown-item">
          日本語
        </div>
      </drop-down>
      <li class="nav-item" v-if="myAccount == null">
        <div
            style="width: 136px; height: 44px; background-image: url('/img/btn_login.png'); font-size: 1.0em;
            margin-top: 0px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            color: #000000; padding-top: 13px;"
            @click="goSignIn()"
            class="btn"
          >{{$t('account_signin')}}</div>
      </li>
      <li class="nav-item" v-if="myAccount != null">
        <div
            style="width: 136px; height: 44px; background-image: url('/img/btn_login.png'); font-size: 1.0em;
            margin-top: 0px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            color: #000000; padding-top: 13px;"
            @click="goAccount()"
            class="btn"
          >{{$t('MyAccount')}}</div>
      </li>
      <!-- <li class="nav-item">
        <n-button
          class="nav-link btn btn-info"
          style="cursor: pointer;"
          @click="openModal('subscribe')"
        >
          <p>{{$t('SUBSCRIBE')}}</p>
        </n-button>
      </li>       -->
      <!-- <li class="nav-item">
        <div
          style="cursor: pointer; background-image: url('/img/event/btn_event.png'); background-size: 100% 100%; width: 42px; height: 46px; margin-left: 10px;"
          @click="goEvent()"
        >
        </div>
      </li> -->
      <!-- <div style="position: absolute; left: 0px; top: 0px; height: 1px; weight: 100%; border: 1px solid #8e6f2f;">
      </div> -->
    </template>    
  </navbar>  
</template>

<script>
import { DropDown, Button, Navbar } from '@/components';
import { Popover } from 'element-ui';
import {connectWallet} from '../../utils/wallet';
import {buy} from '../../utils/paypalpay';

export default {
  name: 'main-navbar',
  props: {
    transparent: Boolean,
    colorOnScroll: Number,
    paddingTop: Boolean
  },
  mounted() {
    connectWallet(this.$store);
  },
  methods: {
    openModal: function(modalName) {
      this.$store.commit(`openModal`, modalName);
    },
    goEvent() {
      this.$router.push('/event');
    },
    goSignIn() {
      this.openModal('wallet');
      //buy("aaa","ddd",4.99);
    },
    goAccount() {
      this.$router.push('/account');
    }
  },
  computed: {
    myAccount() {
      if (this.$store.state.account.wallet == null) {
        return null;
      }
      return this.$store.state.account.wallet?.address;
    }
  },
  components: {
    DropDown,
    Navbar,
    [Button.name]: Button,
    [Popover.name]: Popover
  }
};
</script>

<style scoped></style>
